module.exports = __webpack_public_path__ + "img/灌溉控制器.92875c24.jpg";